import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;

const normalizeParams = (params = {}) => {
  const clean = { ...params };

  Object.keys(clean).forEach((key) => {
    const value = clean[key];
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete clean[key];
    }
  });

  return clean;
};

export const getAggregatedSearches = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/admin/searches/aggregated`, {
    withCredentials: true,
    params: normalizeParams(params),
  });
  return data;
};

export const getSearchEvents = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/admin/searches`, {
    withCredentials: true,
    params: normalizeParams(params),
  });
  return data;
};

export const exportSearchEvents = async (params = {}) => {
  const response = await axios.get(`${API_URL}/admin/searches/export`, {
    withCredentials: true,
    params: normalizeParams(params),
    responseType: "blob",
  });

  return response;
};
